import { Injectable } from '@angular/core';
import { NotificationsService, Notification } from 'angular2-notifications';

@Injectable()
export class NotifyService
{
    constructor(private ns: NotificationsService)
    {

    }

    public TMS(title: string, message: string): Notification
    {
        let notification: Notification = this.ns.success(title, message);
        return notification;
    }

    public TMI(title: string, message: string): Notification
    {
        let notification: Notification = this.ns.info(title, message);
        return notification;
    }

    public TMW(title: string, message: string): Notification
    {
        let notification: Notification = this.ns.warn(title, message);
        return notification;
    }

    public TME(title: string, message: string): Notification
    {
        let notification: Notification = this.ns.error(title, message);
        return notification;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/notify.service.ts